import React, { Component, Fragment } from "react";
import { Icon } from "antd";
import _ from "lodash";
import styled from "styled-components";

const MediaIcon = styled(Icon)`
	font-size: 250px;
	color: black;
`;

class ContentMedia extends Component {
	renderMedia(type) {
		let mediaType = "picture";
		if (type === "Photo") {
			mediaType = "camera";
		} else if (type === "Video") {
			mediaType = "video-camera";
		} else if (type === "Audio") {
			mediaType = "sound";
		}
		return <MediaIcon type={mediaType} />;
	}

	render() {
		const { type, quantity } = this.props;

		return (
			<Fragment>
				<div className="p-survey-simulation-phone-media">
					{this.renderMedia(type)}
					<div className="p-survey-simulation-phone-media-text">{quantity}</div>
				</div>
			</Fragment>
		);
	}
}

export default ContentMedia;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/Content/ContentMedia.js